var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"color":_vm.chipColor,"text-color":_vm.textColor,"x-small":"","label":""}},[_vm._v(" "+_vm._s(_vm.chipLabel)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }